<!--摆场汇总-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <a-range-picker slot="submitTime" v-model="queryParams.submitTime" valueFormat="YYYY-MM-DD" allowClear />
        <global-select
          slot="statusList"
          :value.sync="queryParams.promotionName"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="analysisSumExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
        <a-button type="primary" @click="handleCompareBtn">差异对比按钮</a-button>
        <div class="compare-date" v-show="dateForm.dateOne">
          所选日期需求差异值=日期<span class="choose-data">{{ dateForm.dateOne }}</span>的数值 - 日期<span class="choose-data">{{ dateForm.dateTwo }}</span>的数值
        </div>
        <comparative-analysis ref="comparativeAnalysisRef" @chooseDate="handleChooseDate" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
          <!--摆场总需求-->
          <template slot="sumDemandQuantity" slot-scope="text">
            <a @click="onSumDemandQuantity(text.record)" href="javascript:;">{{ text.record.sumDemandQuantity }}</a>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import comparativeAnalysis from '@/views/scp/producingAndMarketing/furniture-placement-demand/analysis/components/comparative-analysis'
import {
  analysisSumList,
  analysisSumExport
} from '@/api/scp/pre-order-and-placement/pre-order-and-placement'

export default {
  // eslint-disable-next-line
  name: 'Demand-summary',
  components: { DownloadModal, comparativeAnalysis },
  data() {
    return {
      statusList: [], // 状态
      analysisSumExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(analysisSumList, false),
        pageCurrent: true
      },
      dateForm: { dateOne: '', dateTwo: '' }, // 差异对比日期
      // 查询参数
      queryParams: {
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined,
        promotionName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '提报日期', decorator: ['submitTime'], type: 'submitTime' },
        { label: '促销名称', decorator: ['promotionName'], type: 'statusList' }
      ],
      // 表格字段
      columns: [
        { title: '促销名称', dataIndex: 'promotionName', align: 'center' },
        { title: '提报日期', dataIndex: 'submitTime', align: 'center', scopedSlots: { customRender: 'dateFormat' }, ellipsis: true },
        { title: '摆场总需求', dataIndex: 'sumDemandQuantity', scopedSlots: { customRender: 'sumDemandQuantity' }, align: 'center' },
        { title: '比前一天变化', dataIndex: 'demandQuantityChange', align: 'center' },
        { title: '所选日期需求差异值', dataIndex: 'choseDayDemandDifferenceQuantity', align: 'center' },
        { title: '提交人', dataIndex: 'submitUserName', ellipsis: true, align: 'center' }
      ]
    }
  },
  created() {
    this.getLookupList('SCP_PLACEMENT_PROMOTION_NAME', 'statusList')
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 跳转流瀑表，带年份和促销名称
    onSumDemandQuantity(data) {
      this.$router.push(
        {
          path: '/scp/furniture-placement-demand/analysis',
          query: { submitYear: data.submitTime ? this.$moment(data.submitTime).format('YYYY') : '', promotionName: data.promotionName }
        }
      )
    },
    // 获取快码
    getLookupList (type, arr) {
      const lookupQueryParams = { lookupType: type, current: 1, pageSize: 999 }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows?.length > 0) {
          this[arr] = response.rows
        }
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      if (this.dateForm?.dateOne && this.dateForm?.dateTwo) {
        params.demandDateBegin = this.dateForm.dateOne + " 00:00:00"
        params.demandDateEnd = this.dateForm.dateTwo + " 23:59:59"
      }
      params.submitTimeStart = params.submitTime && params.submitTime[0] ? (params.submitTime[0] + " 00:00:00") : undefined
      params.submitTimeEnd = params.submitTime && params.submitTime[1] ? (params.submitTime[1] + " 23:59:59") : undefined
      const queryObj = cloneDeep(params)
      if (queryObj?.submitTime) { delete queryObj.submitTime }
      this.$refs.dataTable.searchParams = queryObj
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined,
        promotionName: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 选择日期后回调显示
    handleChooseDate(form) {
      this.$set(this.dateForm, 'dateOne', form?.dateOne)
      this.$set(this.dateForm, 'dateTwo', form?.dateTwo)
      this.onSearch()
    },
    // 差异对比
    handleCompareBtn() {
      this.$refs.comparativeAnalysisRef.show();
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.compare-date{
  color:#f5222d;
  padding-left:20px;
  .choose-data{
    font-weight: 700;
  }
}
</style>
